const BankvoleLoanTerms = () => {
  return (
    <div className="ims-policy-container">
      <header>
        <h1>LOAN TERMS OF USE</h1>
      </header>

      <main>
        <strong>Effective Date: September 2026</strong>

        <p>
          These Loan Terms of Use (“Terms”) govern the use of the loan feature
          (“Loan Service”) available on the Bankvole mobile application (“the
          App”). By accessing or using the Loan Service, you agree to be bound
          by these Terms.
        </p>

        <p>If you do not agree, please do not use the Loan Service.</p>

        {/* Section 1 */}
        <section>
          <h2>1. Eligibility</h2>

          <p>Access to the Loan Service is strictly limited to:</p>

          <ol type="a">
            <li>
              <strong>Fixed Savings Customers:</strong> Users who have funds
              saved/invested on the App with a maturity date in the future
              (“Eligible Savings”) but whose funds have not yet matured for
              withdrawal.
            </li>

            <li>
              <strong>Payroll Lending Customers:</strong> Users enrolled in the
              Company’s payroll lending scheme as confirmed by their employer.
            </li>
          </ol>

          <p>No other customers are eligible for the Loan Service.</p>
        </section>

        {/* Section 2 */}
        <section>
          <h2>2. Loan Tenor</h2>

          <ul>
            <li>
              All loans under the Loan Service shall have a maximum tenor of
              thirty (30) calendar days from the date of disbursement (“Loan
              Tenor”).
            </li>

            <li>Loans must be repaid in full on or before the due date.</li>
          </ul>
        </section>

        {/* Section 3 */}
        <section>
          <h2>3. Loan Amount and Disbursement</h2>

          <ul>
            <li>
              The maximum loan amount shall be determined by the Company at its
              sole discretion, based on:
              <ul>
                <li>The value of the Eligible Savings, or</li>
                <li>
                  The verified payroll record for Payroll Lending Customers.
                </li>
              </ul>
            </li>

            <li>
              Loan proceeds shall be disbursed into the user’s designated
              wallet/account within the App.
            </li>
          </ul>
        </section>

        {/* Section 4 */}
        <section>
          <h2>4. Interest, Fees and Charges</h2>

          <ul>
            <li>
              The applicable <strong>interest rate, fees or charges</strong> for
              each loan shall be displayed to the customer before loan
              acceptance.
            </li>

            <li>
              By accepting the loan, the customer agrees to the displayed
              interest rate and charges.
            </li>
          </ul>
        </section>

        {/* Section 5 */}
        <section>
          <h2>5. Repayment Terms</h2>

          <ul>
            <li>
              Repayment shall be automatically deducted from:
             
                <p>
                  a. The customer’s bank account linked to the Bankvole app via
                  Mono direct debit
                </p>
                <p>b. The customer’s Bankvole wallet, or</p>
                <p>
                  c. The customer’s <strong>Eligible Savings</strong> upon
                  maturity.
                </p>
              
            </li>

            <li>
              Customers may also choose to repay earlier through the App’s
              repayment feature.
            </li>
          </ul>
        </section>

        {/* Section 6 */}
        <section>
          <h2>6. Default and Consequences</h2>

          <p>
            A loan shall be deemed in default if repayment is not received in
            full on or before the due date. Upon default:
          </p>

          <ul>
            <li>
              The Company may deduct the outstanding amount from any funds
              available in the linked bank account, App wallet or eligible
              savings.
            </li>

            <li>
              The Company reserves the right to report defaulting customers to
              relevant credit bureaus in accordance with applicable laws.
            </li>

            <li>
              The Company may take necessary legal action for loan recovery.
            </li>
          </ul>
        </section>

        {/* Section 7 */}
        <section>
          <h2>7. Restrictions</h2>

          <ul>
            <li>
              Customers may <strong>not withdraw or liquidate</strong> Eligible
              Savings used as collateral until the loan is fully repaid.
            </li>

            <li>
              Customers under payroll lending agree that their employers may be
              notified of any default.
            </li>
          </ul>
        </section>

        {/* Section 8 */}
        <section>
          <h2>8. Customer Obligations</h2>

          <p>Customers agree to:</p>

          <ul>
            <li>Provide accurate and up-to-date information at all times.</li>

            <li>Use the loan only for lawful purposes.</li>

            <li>Repay all loans according to the agreed terms.</li>
          </ul>
        </section>

        {/* Section 9 */}
        <section>
          <h2>9. Company Rights</h2>

          <p>The Company reserves the right to:</p>

          <ul>
            <li>
              Amend these Terms at any time, without prior notice to customers.
            </li>

            <li>
              Refuse loan applications where eligibility conditions are not met.
            </li>

            <li>
              Vary interest rates or loan limits based on market conditions or
              internal policies.
            </li>
          </ul>
        </section>

        {/* Section 10 */}
        <section>
          <h2>10. Data Protection and Privacy</h2>

          <p>
            All personal and financial data provided by customers shall be
            processed in accordance with the Company’s{" "}
            <strong>Privacy Policy</strong> and applicable data protection laws.
          </p>
        </section>

        {/* Section 11 */}
        <section>
          <h2>11. Governing Law</h2>

          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of the Federal Republic of Nigeria.
          </p>
        </section>

        {/* Section 12 */}
        <section>
          <h2>12. Acceptance</h2>

          <p>
            By clicking “Accept” or proceeding with a loan request, you
            acknowledge that you have read, understood, and agreed to be bound
            by these Terms.
          </p>
        </section>
      </main>
    </div>
  );
};

export default BankvoleLoanTerms;
